import { addScript } from 'apps/promo/helpers/DOM';

const SCRIPT_URL = '/libphonenumber-mobile.js?v=1.10.60';
let loadPromise: Promise<boolean> | null = null;

export const ensureLibPhonenumberLoaded = (): Promise<boolean> => {
    if (!__isBrowser__ || typeof window === 'undefined') return Promise.resolve(false);
    if (window.libphonenumber) return Promise.resolve(true);
    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve) => {
        const existing = typeof document !== 'undefined' ? document.querySelector<HTMLScriptElement>(`script[src*="${SCRIPT_URL}"]`) : null;
        if (existing) {
            existing.addEventListener('load', () => resolve(true), { once: true });
            return;
        }
        addScript(SCRIPT_URL, () => resolve(true));
    });
    return loadPromise;
};
